import { create } from 'zustand';

/**
 * Detail payload sent by the backend on HTTP 402 (insufficient tokens).
 * Mirrors the dict shape produced by `require_tokens` in dependencies.py.
 */
export interface InsufficientTokensDetail {
  error: 'insufficient_tokens';
  message: string;
  cost: number;
  balance: number;
  subscription_active: boolean;
}

interface BillingState {
  /** When non-null, the "Sin saldo" modal is open. */
  insufficient: InsufficientTokensDetail | null;
  openInsufficient: (detail: InsufficientTokensDetail) => void;
  closeInsufficient: () => void;
}

export const useBillingStore = create<BillingState>((set) => ({
  insufficient: null,
  openInsufficient: (detail) => set({ insufficient: detail }),
  closeInsufficient: () => set({ insufficient: null }),
}));
